import { Outlet } from "react-router-dom";

export default function AppMain(){
    return (
        <>
       <Outlet/>
        </>
    )
}